import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, untracked } from '@angular/core';

import { AppError, CommonMediaQueries, MediaScreenService } from '@hglobal/common';
import { combineLatest } from 'rxjs';

import { AuthService } from '@pp/core/auth-store';
import { redirectToUrl } from '@pp/core/helpers';
import { GlobalToastService, ThemeService } from '@pp/core/services';
import { PermissionsStore, StorageStore } from '@pp/core/store';
import { ShellStore } from '@pp/shell';

import { ActionItemComponent } from './action-item/action-item.component';
import { RoutingItemComponent } from './routing-item/routing-item.component';

@Component({
  imports: [RoutingItemComponent, ActionItemComponent, AsyncPipe],
  selector: 'pp-nav, [ppNav]',
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent {
  readonly #shellStore = inject(ShellStore);
  readonly #storageStore = inject(StorageStore);
  readonly #auth = inject(AuthService);
  readonly #mediaScreenService = inject(MediaScreenService);
  readonly #globalToastService = inject(GlobalToastService);
  readonly themeService = inject(ThemeService);
  readonly permissions = inject(PermissionsStore);

  settings = this.#shellStore.appSettings;
  breakpoints$ = combineLatest({
    isDesktop: this.#mediaScreenService.mediaMatcher(CommonMediaQueries.LG),
  });
  ordId = this.#storageStore.orgId;

  generateTelegramLinkSuccessEffect = effect(() => {
    const success = this.#shellStore.isGenerateTelegramLinkSuccess();
    if (success) {
      untracked(() => {
        redirectToUrl(this.#shellStore.telegramLink());
        this.#shellStore.resetGenerateTelegramLink();
      });
    }
  });

  generateTelegramLinkFailureEffect = effect(() => {
    const error = this.#shellStore.generateTelegramLinkError();
    if (error) {
      this.#onChangeError(error);
    }
  });

  get themeTranslation(): string {
    return this.themeService.isDarkTheme ? 'shell.sidebar.nav.lightTheme' : 'shell.sidebar.nav.darkTheme';
  }

  startRedirectToAgentAccounts(): void {
    this.#shellStore.generateTelegramLink(this.ordId());
  }

  logout() {
    this.#auth.logout();
  }

  #onChangeError(error: AppError): void {
    this.#globalToastService.showErrorWithTitle(error?.originalError?.error?.error_description);
  }
}
